<template>
    <span :class="highlightClass">
        {{ content }}
    </span>
</template>

<script>
    export default {
        props: {
            content: { type: String, required: true },
        },

        data() {
            return {
                highlightClass: '',
            }
        },

        methods: {
            triggerHighlight() {
                this.highlightClass = ''
                setTimeout(() => (this.highlightClass = 'highlight'))
            },
        },

        watch: {
            content(newContent, oldContent) {
                if (newContent === oldContent) {
                    return
                }

                this.triggerHighlight()
            },
        },
    }
</script>
